export default __webpack_public_path__ + "re_project-500-f5b3f2247eedd3b24a678357c1930f7f.png";